var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"text-h6",attrs:{"id":_vm.inputName,"value":_vm.inputValue,"label":_vm.label,"outlined":"","readonly":""},on:{"focus":_vm.onInputFocus,"input":_vm.onInputChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }